import { render } from "./TariffElement.vue?vue&type=template&id=067f935d"
import script from "./TariffElement.vue?vue&type=script&lang=js"
export * from "./TariffElement.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/standart-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__